import React, {useState} from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import HeaderMenu from './HeaderMenu';
import NativeHeader from './GroupingButton';
// import SearchBar from './SearchBar';
import HeaderTab from './HeaderTab';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const Header = props => {

  const [menu, setMenu] = useState(false);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const isNativeHeader = props.data.id === 'dt_group_checkbox';

  const containerStyles = {
    ...styles.headerCell,
    width: props.data.widthValue,
    zIndex: props.controller.searchingHeader === props.index ? 2 : null,
  }
  const bufferStyles = {
    ...styles.headerBuffer,
    borderRight: props.last ? 'none' : styles.headerBuffer.borderRight
  }

  const toggleMenuOn = () => isNativeHeader ? null : setMenu(true);
  const toggleMenuOff = () => isNativeHeader ? null : setMenu(false);

  const toggleSort = () => {
    if (!isNativeHeader && props.data.sortable !== false) {
      props.controller.sortData(props.index);
      props.controller.render();
    }
    handleActivityLogUpdate(`Header.toggleSort`)
  }
 const openSearch = () => {
    props.controller.searchingHeader = props.index;
    props.controller.searchActive = true;
    props.controller.render(true);
 };

  return(
    <div style={containerStyles}
      onMouseEnter={toggleMenuOn}
      onMouseLeave={toggleMenuOff}
    >
      <div style={styles.headerTab}>
        {
          props.controller.searchingHeader === props.index && props.controller.queryString ?
          <HeaderTab
            index={props.index}
            first={props.first}
            last={props.last}
          />
          : ''
        }
      </div>
      {isNativeHeader
        ? <NativeHeader {...props} bufferStyles={bufferStyles} />
        : <Button
          onClick={toggleSort}
          styles={bufferStyles}
          hoverStyles={styles.headerBufferHov}
          activeStyles={styles.headerBufferAct}
          focusStyles={styles.headerBufferFoc}
          title={props.data.title}
        >
          <div style={styles.sortIndicator}>
            {props.controller.sortIndex.index === props.index &&
              <svg style={styles.sortSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                {props.controller.sortIndex.toBottom
                  ? <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/>
                  : <path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"/>
                }
              </svg>
            }
          </div>
          <div style={{
            ...styles.cellContent,
            // Title was overlapping the chevronDown/chevronUp icon
            padding: props.controller.sortIndex.index === props.index ? '2px 2px 2px 20px' : styles.cellContent.padding
          }}>
            <h4 style={styles.headerText}>{props.data.title}</h4>
          </div>
          {!props.last && <span style={styles.headerSpacer}></span>}
        </Button>
      }
      {/* Sub Menu */}
      {
      //   menu && props.controller.searchingHeader !== props.index
      // && (props.data.searchable !== false || props.data.sortable !== false) &&
      //   <HeaderMenu
      //     index={props.index}
      //     controller={props.controller}
      //     tip={props.data.tip}
      //     first={props.first}
      //     last={props.last}
      //     searchable={props.data.searchable}
      //     openSearch={openSearch}
      //   />
      }
      <HeaderMenu
        index={props.index}
        controller={props.controller}
        tip={props.data.tip}
        first={props.first}
        last={props.last}
        searchable={props.data.searchable}
        openSearch={openSearch}
        showSearch={props.controller.searchingHeader !== props.index}
      />
    </div>
  )
}

export default Header;
